import { useEffect } from 'react';
import { PostValidateBatchActionType } from '@/dashboard/components/ValidateBatchButtonLoader/postValidateBatchReducer';
import { RTKQueryDerivedBooleansType } from '@/components/QueryResponseLoader/QueryResponseLoader';
import { ValidateBatchMinifiedResponse } from '@/validation-service/services/validationApi';

export function useDispatchValidateBatchBooleans<
  T extends RTKQueryDerivedBooleansType<ValidateBatchMinifiedResponse | undefined>,
>(booleans: T, dispatch: (value: PostValidateBatchActionType) => void) {
  const { data, isError, error, isSuccess } = booleans;
  useEffect(() => {
    dispatch({
      isError: isError,
      isSuccess: isSuccess,
      data: data,
      error: error,
    });
  }, [data, isError, isSuccess, error]);
}

export function useDispatchValidateBatchOnSuccess<K, T extends RTKQueryDerivedBooleansType<K>>(
  booleans: T,
  alertMessage: string,
  onEvent: () => void,
) {
  const { isError, isSuccess, isUninitialized } = booleans;
  useEffect(() => {
    if (!isUninitialized && (isSuccess || isError) && alertMessage != '') {
      onEvent();
    }
  }, [isUninitialized, isSuccess, isError, alertMessage]);
}
